import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

interface Props {
  open: boolean;
  onReject: (comment: string) => void;
  onCancel: () => void;
}

/**
 * Dialog for admin to optionally provide a rejection comment.
 * The comment is optional: the submit button is always enabled and
 * onReject is called with comment.trim() (which may be an empty string).
 */
export default function RejectOpportunityDialog({ open, onReject, onCancel }: Props) {
  const [comment, setComment] = useState('');

  const handleReject = () => {
    onReject(comment.trim());
    setComment('');
  };

  const handleCancel = () => {
    setComment('');
    onCancel();
  };

  return (
    <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="sm">
      <DialogTitle>Rechazar solicitud</DialogTitle>
      <DialogContent>
        <TextField
          id="reject-comment"
          label="Comentario"
          value={comment}
          onChange={e => setComment(e.target.value)}
          multiline
          rows={3}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button variant="contained" color="error" onClick={handleReject}>
          Rechazar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
